import { LocaleStartParams } from '@platform-frontend/transloco';
import { AuthenticationContext } from '../auth-context';

export type AuthenticationAutostartParams = UpdatePasswordAutostartParams | ConfirmEmailAutostartParams;

export interface UpdatePasswordAutostartParams extends LocaleStartParams {
  type: 'setPassword' | 'resetPassword';
  email: string;
  restoreId: string;
  returnPath: string | null;
}

export interface ConfirmEmailAutostartParams extends LocaleStartParams {
  type: 'confirmEmail';
  context: AuthenticationContext;
  returnPath: string | null;
  errorType: string | null;
}
